import { makeObservable, observable } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";
import { LoginModel, LoginModelValidator } from "./LoginModel";
import { ICommand, RelayCommand } from "Application/Commands";
import { APIClient } from "Application";
import { AccountStore } from "Stores/Domain";
import { singleton, container } from "tsyringe";
import { POSTLoginEndpoint } from "./POSTLoginEndpoint";
import { AppUrls } from "AppUrls";

@singleton()
export class LoginViewModel extends ViewModelBase<LoginModel> {
    public apiClient = new APIClient();
    public postLoginEndpoint = new POSTLoginEndpoint(this);
    public signInViewActive: boolean = true;
    public signUpViewActive: boolean = false;

    constructor() {
        super(new LoginModel());

        this.setValidator(new LoginModelValidator());

        makeObservable(this, {
            signInViewActive: observable,
            signUpViewActive: observable,
        });
    }

    public accountStore = container.resolve(AccountStore);

    public updateEmailCommand: ICommand = new RelayCommand((value: string) => this.updateField("emailAddress", value));
    /*public updateEmailCommand: ICommand = new RelayCommand((value: string) => {
        this.model.emailAddress = value;
    });*/

    public updatePasswordCommand: ICommand = new RelayCommand((value: string) => this.updateField("password", value));

    public rememberMeCommand: ICommand = new RelayCommand((value: string) => this.updateField("rememberMe", value));

    public loginCommand: ICommand = new RelayCommand(async () => {
        if (this.isModelValid()) {
            await this.apiClient.sendAsync(this.postLoginEndpoint, this.model);
            if (this.apiClient.IsRequestSuccessful && this.accountStore.IsLoggedIn) {
                this.history.push(this.getPostLoginTargetPath());
            }
        }
    });

    private getPostLoginTargetPath(): string {
        const state = this.history.location.state as { from?: { pathname: string; search?: string } } | undefined;
        const from = state?.from;
        const pathname = from?.pathname;
        if (pathname && pathname !== AppUrls.Client.Home && !pathname.startsWith("/account") && from) {
            return `${pathname}${from.search ?? ""}`;
        }
        if (this.accountStore.isMentor) {
            return AppUrls.Client.Admin.Mentor.WeeklyRota;
        }
        return AppUrls.Client.Students.Current;
    }

    private updateField = (fieldName: keyof FieldType<LoginModel>, value: any) => {
        this.setValue(fieldName, value);
        this.isFieldValid(fieldName);
    };
}
